

export const screenXs = 480;
export const screenSm = 768;
export const screenMd = 992;
export const screenLg = 1200;

export const navbarHeight = 40;

export const tabStyle = {height:36};

export const FIELD_HEIGHT = 54;

export const GOOGLE_API_KEY = "AIzaSyD3Yrf-31-8sL58tKfWwWI_-RpKM4wMw3Y";



// WEBPACK FOOTER //
// ./src/core/common/config/variables.ts